import { useEffect } from 'react';

/**
 * RUI-07: the microphone comes back on at the start of every new call. Only
 * the toggle buttons wrote isMuted, so a mute survived into the next call.
 * A call is identified by its id, or by its prospect for a contact without one.
 */
export function useUnmuteOnNewCall(
  connectedContact: { callId?: string | null; prospect_id?: string | null } | null | undefined,
  setIsMuted: (muted: boolean) => void,
): void {
  const callKey = connectedContact?.callId || connectedContact?.prospect_id || null;
  useEffect(() => {
    if (callKey) setIsMuted(false);
  }, [callKey, setIsMuted]);
}
